// extracted by mini-css-extract-plugin
module.exports = {"lazy":"lazy-image_lazy__su7R_","lazyLoaded":"lazy-image_lazyLoaded__icQo2"};